import type { PaymentMethod } from "@mallardbay/lib-react-components"
import { PAYMENT_METHOD_TYPE } from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"

// Used for representing external payment method in radio group.
export const PAY_WITH_CHECK_VALUE = "pay-with-check"

export function getCheckPaymentMethod(): PaymentMethod {
    return {
        id: PAY_WITH_CHECK_VALUE,
        title: COPY.PAY_WITH_CHECK,
        type: PAYMENT_METHOD_TYPE.CHECK,
    }
}

export function getDefaultPaymentMethod(paymentMethods: PaymentMethod[]) {
    const defaultPaymentMethod = paymentMethods.find(
        (paymentMethod) => paymentMethod.is_default
    )

    return defaultPaymentMethod ?? paymentMethods[0]
}

export function isPaymentMethodAch(paymentMethod: PaymentMethod | undefined) {
    return paymentMethod?.type === PAYMENT_METHOD_TYPE.BANK_ACCOUNT
}
